export const environment = {
  production: true,
  singleEvent: false,
};
